export default __webpack_public_path__ + "static/media/orthopedics.350771ac.svg";